/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dashboard-manage i.fa-times{vertical-align:middle}.dashboard-manage .ui-widget-overlay{position:absolute}"];
export { styles as styles };
